import gql from "graphql-tag";
import { formatDate_YMDHMS, roundDateToFloor } from "@/_core/_helpers/_helpers";
/**
 * Exposure data, with Fwd Valuation
 * @param {string} _this: context variable
 * @param {boolean} daysToExpiration: Days to expiracion list
 */
export function readCurrencyValuationDataOptimizer(_this, daysToExpiration) {
  return _this.$apollo.query({
    query: gql`
      query(
        $currency: Int!
        $days_to_expiration: daysToExpirationList
        $format: String
        $last: Int!
        $observation_date: String
      ) {
        currency_valuation_inputs(
          currency: $currency
          days_to_expiration: $days_to_expiration
          format: $format
          last: $last
          observation_date: $observation_date
        ) {
          pk_idcurrencyvaluationinput
          days_to_expiration
          observation_date
          fwd
          r
          rf
          d0
          c0
          c1
          c2
          fk_idcurrency
        }
      }
    `,
    variables: {
      format: "json",
      currency: _this.currencyNumber,
      last: 1,
      days_to_expiration: { values: daysToExpiration },
      observation_date: Date().toLocaleString()
    }
  });
}
